enum Mutations {
  SET_PAYMENT_METHODS = 'setPAymentMethods',
}

export default Mutations
